import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CapoeiraSportState from './context';
import CapoeiraSportModalState from './context/modal';
import Menu from './containers/menu';
import CapoeiraRoute from './pages';
import Footer from './containers/footer';
import ScrollTopButton from './components/scrollTop';


import './techstyle.css';
import './globalstyle.css';
import './style.css';
import 'antd/dist/antd.css';

export default withRouter(class MainApp extends Component {

    constructor(props) {
        super(props);
        this.mainCenterContainerStyle = 'main-center-container';
        if (CapoeiraSportState.FORCE_MOBILE || /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
            this.isMobile = true;
            this.mainCenterContainerStyle = 'main_center_container_mobile'
        }
        // this.isMobile = true;
        // this.mainCenterContainerStyle = 'main_center_container_mobile'
    }

    // При смене роута (SPA, React Router) сбрасываем скролл скролл-контейнера #root наверх,
    // иначе страница перерисовывается, сохраняя старую позицию прокрутки.
    componentDidUpdate(prevProps) {
        const prevPath = prevProps.location && prevProps.location.pathname;
        const curPath = this.props.location && this.props.location.pathname;
        if (prevPath !== curPath) {
            const scroller = document.getElementById('root');
            if (scroller) scroller.scrollTop = 0;
            else window.scrollTo(0, 0);
        }
    }

    render() {
        return <CapoeiraSportState>
            <div className='main-container'>
                <input style={{ position: 'fixed', top: -30, color: 'white', height: 0 }} id='copyCopyText' value='' />
                <div id='main-backimage-id' className='main-backimage' />
                <div className={this.mainCenterContainerStyle}>
                    <Menu />
                    <CapoeiraRoute />
                </div>
                <Footer />
            </div>
            <CapoeiraSportModalState />
            {/* кнопка «наверх»: появляется при прокрутке вниз */}
            <ScrollTopButton />
        </CapoeiraSportState>
    }


});